export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'

export const GET_ALL_USER_CREDIT = 'GET_ALL_USER_CREDIT'
export const GET_ALL_GIFT_CARDS = 'GET_ALL_GIFT_CARDS'
export const GET_SINGLE_GIFT_CARD = 'GET_SINGLE_GIFT_CARD'
export const GET_ALL_USED_GIFT_CARDS = 'GET_ALL_USED_GIFT_CARDS'
